var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaferGambling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.466 21.397l-1.153.474a.823.823 0 01-.626 0l-1.153-.474.57-1.387.896.368.895-.368a10.663 10.663 0 006.605-9.86V6.376L12 3.6 4.5 6.377v3.772a10.663 10.663 0 006.605 9.86l-.571 1.388A12.162 12.162 0 013 10.149V6.03a1 1 0 01.653-.937l8-2.963a1 1 0 01.694 0l8 2.963a1 1 0 01.653.937v4.12a12.162 12.162 0 01-7.534 11.248zm2.573-11.875a.75.75 0 00-1.078-1.044l-4.307 4.444-1.615-1.666A.75.75 0 107.96 12.3l2.154 2.222.539.556.538-.556 4.847-5z",
    fill: "currentColor"
  })));
}
SvgSaferGambling.displayName = 'SaferGambling';
export default SvgSaferGambling;